import useMediaQuery from 'hooks/useMediaQuery'
import { MOBILE_WIDTH } from 'utils/constants'
import { Connector } from './Connector'
import { StepButton } from './StepButton'
import { StepsContainer } from './styles'

interface StepProps {
  step?: 1 | 2 | 3
  isCarrinhoWa?: boolean
}
function Step({ step = 1, isCarrinhoWa = false }: StepProps) {
  const isMobile = useMediaQuery(MOBILE_WIDTH)
  if (isCarrinhoWa) {
    return (
      <StepsContainer isMobile={isMobile} isCarrinhoWa>
        <StepButton step="cart" active />
        <Connector disabled />
        <StepButton step="analytics" disabled />
      </StepsContainer>
    )
  }
  return (
    <StepsContainer isMobile={isMobile}>
      <StepButton step="cart" active />
      <Connector disabled />
      <StepButton step="documents" disabled={step === 1} active={step === 2} />
      <Connector disabled />
      <StepButton step="analytics" disabled={step < 3} active={step === 3} />
    </StepsContainer>
  )
}

export default Step
